/* eslint-disable no-process-env */
import { execute } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import envDetect from '@tcc/env-detect';
import { OL_V1, OL_V2 } from "../constants/ol";

// TODO: Replace all of this with a proper Apollo Client.
const getGqlUri = (version) => {
  if (envDetect.getCurrentEnv() === envDetect.environments.PRODUCTION) {
    return `https://ol.na.climate.com/${version}/graphql`;
  }
  return `/${version}/graphql`;
};

const headers = {
  'x-http-caller-id': process.env.npm_package_name,
  'x-http-caller-version': process.env.npm_package_version,
  'content-type': 'application/json',
};

const linkV1 = new HttpLink({
  uri: getGqlUri(OL_V1),
  headers,
  credentials: 'include',
});

const linkV2 = new HttpLink({
  uri: getGqlUri(OL_V2),
  headers,
  credentials: 'include',
});

export function olConnectionV1(request) {
  return new Promise((resolve, reject) => {
    execute(linkV1, request).subscribe({
      next: (data) => resolve(data),
      error: (error) => reject(error),
    });
  });
}

export function olConnectionV2(request) {
  return new Promise((resolve, reject) => {
    execute(linkV2, request).subscribe({
      next: (data) => resolve(data),
      error: (error) => reject(error),
    });
  });
}
